/**
 * The computer's wallpapers. Static table: keys are persisted in
 * computerStore (`desktop.wallpaper`), srcs live under /public/wallpapers,
 * and `tone` is precomputed from the top-left of each image (where the
 * menubar sits) so label colours flip without sampling pixels at runtime.
 */
export type WallpaperKey =
  | 'dawn-lake' | 'still-lake' | 'cloud-sea' | 'dunes' | 'moonlight' | 'morning-mist'
  | 'first-light' | 'aurora' | 'gold-silk' | 'lavender' | 'blue-hour';

export interface Wallpaper {
  key: WallpaperKey;
  name: string;
  src: string;
  /** Luminance of the region behind the menubar: light → ink text, dark → white text. */
  tone: 'light' | 'dark';
}

export const WALLPAPERS: readonly Wallpaper[] = [
  { key: 'dawn-lake',    name: 'Dawn lake',    src: '/wallpapers/wp-01-dawn-lake.webp',    tone: 'light' },
  { key: 'still-lake',   name: 'Still lake',   src: '/wallpapers/wp-11-still-lake.webp',   tone: 'light' },
  { key: 'cloud-sea',    name: 'Cloud sea',    src: '/wallpapers/wp-02-cloud-sea.webp',    tone: 'light' },
  { key: 'dunes',        name: 'Dunes',        src: '/wallpapers/wp-03-dunes.webp',        tone: 'light' },
  { key: 'moonlight',    name: 'Moonlight',    src: '/wallpapers/wp-04-moon-ocean.webp',   tone: 'dark' },
  { key: 'morning-mist', name: 'Morning mist', src: '/wallpapers/wp-05-morning-mist.webp', tone: 'dark' },
  { key: 'first-light',  name: 'First light',  src: '/wallpapers/wp-06-fuji.webp',         tone: 'light' },
  { key: 'aurora',       name: 'Aurora',       src: '/wallpapers/wp-07-aurora.webp',       tone: 'dark' },
  { key: 'gold-silk',    name: 'Gold silk',    src: '/wallpapers/wp-08-gold-silk.webp',    tone: 'light' },
  { key: 'lavender',     name: 'Lavender',     src: '/wallpapers/wp-09-lavender.webp',     tone: 'light' },
  { key: 'blue-hour',    name: 'Blue hour',    src: '/wallpapers/wp-10-himalaya.webp',     tone: 'dark' },
];

export const DEFAULT_WALLPAPER: WallpaperKey = 'dawn-lake';

export function wallpaperByKey(key: string): Wallpaper {
  return WALLPAPERS.find((w) => w.key === key) ?? WALLPAPERS[0];
}
